import { render } from "./ClickBoxComponent.vue?vue&type=template&id=0b4e40c0&scoped=true"
import script from "./ClickBoxComponent.vue?vue&type=script&lang=js"
export * from "./ClickBoxComponent.vue?vue&type=script&lang=js"

import "./ClickBoxComponent.vue?vue&type=style&index=0&id=0b4e40c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4e40c0"]])

export default __exports__